import { toast } from 'react-toastify';
import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import {
    fetchGstr3bDataService,
    fetchRevenueVendorExpenseTableDataService,
    getGstReportsService,
    generateGstAnalysisReportService,
} from './revenueVendorExpensesService';
import { Handlers } from '../../../types/actions/types';
import { GstAnalysisReportMeta } from './types';

export async function fetchRevenueVendorExpenseTableData(payload, handlers: Handlers) {
    try {
        const response = await fetchRevenueVendorExpenseTableDataService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.data || {});
                return;
            case JAVA_API_STATUS.ERROR:
                return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}

export async function fetchGstr3bData(payload, handlers: Handlers) {
    try {
        const response = await fetchGstr3bDataService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.data || {});
                return response?.data?.responseBody;
            case JAVA_API_STATUS.ERROR:
            // return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}

export async function generateGstAnalysisReport(orgId: string): Promise<GstAnalysisReportMeta | null> {
    try {
        const response = await generateGstAnalysisReportService({ orgId });
        const data = response?.data?.data;
        if (data?.mnemosyneDocId) {
            return { mnemosyneDocId: data.mnemosyneDocId, fileName: data.fileName };
        }
        toast.error('Failed to generate GST Analysis Report');
        return null;
    } catch (err) {
        toast.error('Failed to generate GST Analysis Report');
        return null;
    }
}

export async function getGSTReports(payload, handlers: Handlers) {
    try {
        const response = await getGstReportsService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.data || {});
                return response?.data?.gstReports || [];
            case JAVA_API_STATUS.ERROR:
            // return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}
